import { Spinner as BaseSpinner, type SpinnerProps } from "@optimyl/ui";

// The shared spinner in Optimyl brand green — bound here so this app has one answer for the colour.
export function Spinner(props: Omit<SpinnerProps, "ringClass">) {
  return <BaseSpinner {...props} ringClass="border-brand-green border-t-transparent" />;
}
